import { render, staticRenderFns } from "./SourceCenter.vue?vue&type=template&id=31061a66&scoped=true"
import script from "./SourceCenter.vue?vue&type=script&lang=js"
export * from "./SourceCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31061a66",
  null
  
)

export default component.exports